import React from 'react';
import { Helmet } from 'react-helmet-async';
import Section from './Section';
import { Container } from 'reactstrap';
import DashboardContent from './DashboardContent';

const ManageJobApplications = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Dashboard | Jobseekers Page </title>
      </Helmet>
      <Section />
      <section className="section">
        <Container>
          <DashboardContent />
        </Container>
      </section>
    </React.Fragment>
  )
}

export default ManageJobApplications